jQuery( 'body' ).ready( function ( $ ) {

  $( '#job_country' ).on( 'change', function () {
    searchJobOpenings();
  } );

  $( '#job_category' ).on( 'change', function () {
    searchJobOpenings();
  } );

  $( '#job_title' ).on( 'change keyup', function () {
    searchJobOpenings();
  } );

  $( 'body' ).on( 'click', '.page-number', ( e ) => {
    var pageID = e.currentTarget.id;
    var paged  = $( '#' + pageID ).attr( 'data-page' );

    searchJobOpenings( paged );
  } );

  $( 'body' ).on( 'click', '#page-previous', () => {
    var paged = $( '#page-previous' ).attr( 'data-previous' );

    searchJobOpenings( paged );
  } );

  $( 'body' ).on( 'click', '#page-next', () => {
    var paged = $( '#page-next' ).attr( 'data-next' );

    searchJobOpenings( paged );
  } );

  /**
   * This function performs an ajax query to render the html result on the page.
   *
   * @param pageCurrent current search page.
   */
  function searchJobOpenings( pageCurrent = 1 ) {
    var $jobtitle    = $( '#job_title' ).val();
    var $jobCountry  = $( '#job_country' ).find( 'option:selected' ).attr( 'value' );
    var $jobCategory = $( '#job_category' ).find( 'option:selected' ).attr( 'value' );

    var $data = {
      action: 'more_post_ajax',
      paged: pageCurrent,
      country: $jobCountry,
      category: $jobCategory,
      title: $jobtitle,
    };
    $.ajax( {
      type: 'POST',
      url: ajax_object.ajax_url,
      data: $data,
      beforeSend: function() {
        $( '.loading-results' ).addClass( 'active' );
        $( '.row-jobs__cards' ).addClass( 'not-show' );
        $( '.results-not-found' ).addClass( 'not-show' );
      },
    } )
      .complete( function ( response ) {
        $( '.loading-results' ).removeClass( 'active' );
        $( '.row-jobs__cards' ).removeClass( 'not-show' );
        $( '.results-not-found' ).removeClass( 'not-show' );
        $( '.containers-loading-search' ).html( response ); // CHANGE THIS!
      } );
  }
} );
